module.exports = __webpack_public_path__ + "img/img-cardnews-01-2.a3c86bd3.png";